import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import './styles.css'

function MoreButton({ variant = 'link', url = '', action = () => {}, cta = 'See More' }) {
  return (
    <div>
      {variant === 'link' && (
        <Link to={url} className="more-button">
          <i className="icon-plus more-button__icon" />
          {cta}
        </Link>
      )}
      {variant === 'action' && (
        <button type="button" className="more-button" onClick={action}>
          <i className="icon-plus more-button__icon" />
          {cta}
        </button>
      )}
    </div>
  )
}

MoreButton.propTypes = {
  action: PropTypes.func,
  cta: PropTypes.string,
  url: PropTypes.string,
  variant: PropTypes.oneOf(['action', 'link'])
}

export default MoreButton
